import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TableEssentialResiduesComponent from '../components/TableEssentialResiduesComponent';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {
    ITableEssentialResiduesData,
    ITableEssentialResiduesFunctions,
    ITableEssentialResiduesContainerProps,
} from '../props/ITableEssentialResiduesComponentProps';
import IMainState from '../../../IMainState';

const mapStateToProps = ({
    mainState,
}: IAppState): ITableEssentialResiduesData => {
    return {
        selectedSiteAnotations: mainState.selectedSiteAnotations,
    };
};

const mapDispatchToProps = (
    dispatch: any
): ITableEssentialResiduesFunctions => ({
    setSelectedSiteAnotations: (
        selectedSiteAnotations: IMainState['selectedSiteAnotations']
    ) => dispatch(ActMain.setSelectedSiteAnotations(selectedSiteAnotations)),
});

const TableEssentialResiduesContainer = connect<
    ITableEssentialResiduesData,
    ITableEssentialResiduesFunctions,
    ITableEssentialResiduesContainerProps
>(
    mapStateToProps,
    mapDispatchToProps
)(TableEssentialResiduesComponent);
export default TableEssentialResiduesContainer;
